import React from 'react';
import { Box } from '@mui/material';
import {
    FaIdCard,
    FaHome,
    FaUserCheck
} from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import ProfileWrapper from './Profile';
import HouseholdRelationshipWrapper from './HouseholdRelationship';
import RegistrationStatusWrapper from './RegistrationSituation';

const menus = [
    {
        title: 'Perfil das Pessoas',
        path: '/governanceroom/dashboardunifiedregistry/people/profile',
        icon: <FaIdCard style={{ marginRight: '5px' }} />
    },
    {
        title: 'Relação Domiciliar',
        path: '/governanceroom/dashboardunifiedregistry/people/household-relationship',
        icon: <FaHome style={{ marginRight: '5px' }} />
    },
    {
        title: 'Situação Cadastral',
        path: '/governanceroom/dashboardunifiedregistry/people/registration-status',
        icon: <FaUserCheck style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardunifiedregistry/people/profile':
        'Perfil das Pessoas Cadastradas',
    '/governanceroom/dashboardunifiedregistry/people/household-relationship':
        'Relação Domiciliar',
    '/governanceroom/dashboardunifiedregistry/people/registration-status':
        'Situação Cadastral'
};

const People = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardunifiedregistry');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="profile"
                            element={<ProfileWrapper />}
                        />
                        <Route
                            path="household-relationship"
                            element={<HouseholdRelationshipWrapper />}
                        />
                        <Route
                            path="registration-status"
                            element={<RegistrationStatusWrapper />}
                        />

                        <Route
                            path="/"
                            element={<Navigate to="profile" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default People;
